import React, { useState } from "react";
import { Card, Button, Modal, Select, Row, Typography } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styled } from "styled-components";
import { faPenToSquare, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import FiltrosEstoque from "./FiltrosEstoque";
import XmlToJsonConverter from "./XmlToJsonConverter ";
import EntradaManual from "./EntradaManual";
import { useConfigQuery } from "../../../../queries/useConfig";

const Estoque = () => {
  const { data: config, error } = useConfigQuery();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const accessToken = window.localStorage.getItem("accessToken");
  const [podeAbandonar, setPodeAbandonar] = useState(true);
  const [msgSairTela, setMsgSairTela] = useState('');

  const handleOpenModal = (component) => {
    setModalContent(component);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setModalContent(null);
  };

  const handleExitClick = () => {
    if (podeAbandonar) {
      const confirmExit = window.confirm(`${msgSairTela}`);
      if (confirmExit) {
        handleCloseModal();
      }
    }
  };

    const bloquearAcesso = (palavra) => {
    if (!palavra) return false;
     if (config.bloqueiosDoUsuario.toLowerCase().includes(String(palavra).toLowerCase())) {
      return true;
    } else {
      return false;
    }

  };


  return (
    <Container>
      <Card style={{ width: "85%", textAlign: "center", backgroundColor: "transparent" }}>
        <Row gutter={[16, 16]} justify="center">

          <ButtonStyled disabled={bloquearAcesso('op.est.estoque')} onClick={() => { setMsgSairTela('Deseja sair do ajuste de estoque?'); handleOpenModal(<FiltrosEstoque handleCloseModal={handleCloseModal} />); }} style={{ backgroundColor: '#d64d4d', width: '150px', height: '150px' }}>
            <FontAwesomeIcon icon={faPenToSquare} size="2x" />
            <ButtonText>Estoque</ButtonText>
          </ButtonStyled>

          <ButtonStyled disabled={bloquearAcesso('op.est.xml')} onClick={() => { setMsgSairTela('Deseja abandonar a entrada de produtos?'); handleOpenModal(<XmlToJsonConverter setPodeAbandonar={setPodeAbandonar} />) }} style={{ backgroundColor: '#4682B4', width: '150px', height: '150px' }}>
            <FontAwesomeIcon icon={faPenToSquare} size="2x" />
            <ButtonText>Entrada XML</ButtonText>
          </ButtonStyled>

          <ButtonStyled disabled={bloquearAcesso('op.est.manual')} onClick={() => { setMsgSairTela('Deseja abandonar a entrada de produtos?'); handleOpenModal(<EntradaManual handleCloseModal={handleCloseModal} />) }} style={{ backgroundColor: '#000000', width: '150px', height: '150px' }}>
            <FontAwesomeIcon icon={faPenToSquare} size="2x" />
            <ButtonText>Entrada Manual</ButtonText>
          </ButtonStyled>


        </Row>
      </Card>

      <Modal
        visible={isModalVisible}
        onCancel={handleExitClick}
        footer={null}
        width="100vw"
        bodyStyle={{ padding: 0 }}
        centered
        closeIcon={null} // Remove o ícone de fechamento padrão
        destroyOnClose={true}
      >
        <ModalHeader>

          <Button
            type="primary"
            disabled={!podeAbandonar}
            onClick={handleExitClick}
            style={{ backgroundColor: "black", borderColor: "black", color: '#fff' }}
          >
            <span>Abandonar <FontAwesomeIcon icon={faSignOutAlt} /></span>
          </Button>
        </ModalHeader>
        <ModalBody>{modalContent}</ModalBody>
      </Modal>
    </Container>
  );
};



const ButtonStyled = styled(Button)`
  width: 150px;
  height: 150px;
  border: none;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  margin: 10px;
  text-align: center;
  padding: 10px;
  overflow: hidden; /* Esconde qualquer conteúdo que ultrapasse o limite do botão */
  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`;

const ButtonText = styled.span`
  margin-top: 10px;
  font-weight: bold;
  text-align: center;
  word-wrap: break-word; /* Quebra o texto para a próxima linha, se necessário */
  width: 100%;
  white-space: normal; /* Permite quebra de linha */
  overflow-wrap: break-word; /* Garante a quebra de palavra se for muito longa */
  display: block;
`;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  height: 100vh;
  position: relative;
`;


const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 0;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 16px;
  background: #fff;
`;

const ModalBody = styled.div`
  padding: 0;
  margin:0;
  height: calc(100vh - 19vh); // Ajusta a altura do corpo do modal
`;


export default Estoque;
